module.exports = __webpack_public_path__ + "media/images/expert__kaisa-makarainen-0166a169c1a67ab0b22086e7ae30acf4.png";